(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/author-profile.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/author-profile.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const useAuthorProfilePicture = svs.components.sportinfo.gameAnalysesRedux.hooks.useAuthorProfilePicture;
const Checkbox = svs.ui.reactForm.Checkbox;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectAuthorProfile = svs.components.sportinfo.gameAnalysesRedux.selectors.selectAuthorProfile;
const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const linkType = svs.component.analyze.constants.linkType;
const VisibilityWrapper = svs.components.lbUi.visibilityWrapper.VisibilityWrapper;
const _React = React,
  useState = _React.useState;
const TARGET_PROFILE_IMAGE_SIZE = 44;
const AuthorProfile = _ref => {
  let authorId = _ref.authorId,
    onToggle = _ref.onToggle,
    selected = _ref.selected;
  const authorProfile = useSelector(state => selectAuthorProfile(state, authorId));
  const profileImage = useAuthorProfilePicture(authorProfile, TARGET_PROFILE_IMAGE_SIZE);
  const authorLinkUrl = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorLinkUrl;
  const authorLinkType = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorLinkType;
  const authorPresentation = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorPresentation;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowAuthorPresentation = _useState2[0],
    setShouldShowAuthorPresentation = _useState2[1];
  let target;
  let rel;
  if (authorLinkType === linkType.EXTERNAL) {
    target = '_blank';
    rel = 'nofollow';
  }
  return React.createElement("div", {
    className: "draw-analysis-author-container"
  }, React.createElement("label", {
    className: "draw-analysis-author"
  }, profileImage && React.createElement("img", {
    alt: "Profil av ".concat(authorProfile.authorLongName),
    src: profileImage,
    style: {
      width: TARGET_PROFILE_IMAGE_SIZE,
      height: TARGET_PROFILE_IMAGE_SIZE
    }
  }), React.createElement("span", {
    className: "draw-analysis-name"
  }, authorProfile.authorLongName), React.createElement("span", {
    className: "draw_analysis_author__checkbox"
  }, React.createElement(Checkbox, {
    checked: selected,
    onChange: onToggle
  }))), React.createElement(VisibilityWrapper, {
    className: "draw_analysis_author__presentation",
    isVisible: shouldShowAuthorPresentation,
    useOpacityTransition: true
  }, React.createElement("span", null, authorPresentation)), authorLinkUrl && React.createElement(ReactButton, {
    className: "draw-analysis-author-link-button",
    href: authorLinkUrl,
    rel: rel,
    size: 300,
    target: target,
    transparent: true
  }, "Till ombudet"), authorPresentation && React.createElement(ReactIconButton, {
    className: "draw_analysis_author__presentation_btn",
    onClick: () => setShouldShowAuthorPresentation(!shouldShowAuthorPresentation)
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: shouldShowAuthorPresentation ? 'menu-up' : 'menu-down',
    size: "100"
  })));
};
setGlobal('svs.component.analyze.AuthorProfile', AuthorProfile);

 })(window);